// extracted by mini-css-extract-plugin
export default {"policy-number-form":"styles_policy-number-form__KYpky"};